export type StatisticsType = 0 | 1 | 2;

interface IStatisticsTypeEnum {
    PowerBI: StatisticsType;
    Nugis: StatisticsType;
    Combined: StatisticsType;
    format(value: number): string | undefined;
    displayTypesArray(): any[];
}

const dataSource = () => [
    { key: 0, text: 'PowerBI' },
    { key: 1, text: 'Nugis' },
    { key: 2, text: 'Abi' }
];

export const statisticsType: IStatisticsTypeEnum = {
    PowerBI: 0,
    Nugis: 1,
    Combined: 2,
    format(value: number) {
        const item = dataSource().find(x => x.key === value);
        return item && item.text;
    },
    displayTypesArray() {
        let types: any[] = [];
        dataSource().map(x => {
            types.push(x);
        });
        return types;
    }
};
